import { useApplyPromoCode, useRemovePromoCode } from '@massilia/queries'
import { AxiosError } from 'axios'
import { useState } from 'react'

/**
 * Promo-code interaction shared by the informations (step 2) and checkout pages.
 * The discount itself lives on the session (server is source of truth); this hook
 * only owns the transient error message and the apply/remove calls.
 */
export function usePromoCode(sessionId: string) {
  const [promoCodeError, setPromoCodeError] = useState<null | string>(null)

  const { isPending: isVerifying, mutateAsync: applyPromoCode } = useApplyPromoCode(sessionId)
  const { mutateAsync: removePromoCodeMutation } = useRemovePromoCode(sessionId)

  const verify = async (code: string) => {
    if (!code.trim()) return
    setPromoCodeError(null)
    try {
      await applyPromoCode({ code: code.trim() })
    } catch (e) {
      const fallback = 'Code promo invalide.'
      const message =
        e instanceof AxiosError && typeof e.response?.data?.message === 'string'
          ? e.response.data.message
          : fallback
      setPromoCodeError(message)
    }
  }

  const remove = async () => {
    setPromoCodeError(null)
    await removePromoCodeMutation()
  }

  return { isVerifying, promoCodeError, remove, verify }
}
